var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[_c('vue-headful',{attrs:{"title":_vm.App_Title}}),_c(_vm.layout,{tag:"component"},[_c('router-view',{staticClass:"col-12"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }